import { Component, inject, input, model, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DisplaysLogsService } from '../../shared/services/displays-logs.service';
import { ContractService } from '../../contract/services/contract.service';
import { AccessService } from '../../core/services/access.service';
import { ContractModel } from '../../shared/models/contract.model';
import { ResourceFormCardComponent } from '../../shared/components/resource-form-card/resource-form-card.component';
import { TurnService } from '../services/turn.service';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ProfileService } from '../../profile/services/profile.service';
import { User, Users } from '../../user/models/user.model';
import { FormService } from '../../shared/services/form.service';
import { BranchModel } from '../../shared/models/branch.model';
import { Servicio, Servicios } from '../../servicios/models/servicio.model';
import { HttpParams } from '@angular/common/http';
import { UserInterface, UsersInterface } from '../../user/interfaces/user.interface';

@Component({
  selector: 'app-turn-per-day',
  standalone: true,
  imports: [
    ResourceFormCardComponent,
    CommonModule,
    ChartModule,
    CalendarModule,
    FormsModule,
    DropdownModule,
  ],
  templateUrl: './turn-per-day.component.html',
  styleUrl: './turn-per-day.component.css',
})
export class TurnPerDayComponent implements OnInit, OnChanges {
  private displaysLogsService = inject(DisplaysLogsService);
  private contractService = inject(ContractService);
  private formService = inject(FormService);
  protected service = inject(TurnService);
  protected access = inject(AccessService).access;
  private profile = inject(ProfileService).profile;

  public detailed = input<boolean>(true);

  basicData: any = undefined;

  basicOptions: any;

  rangeDates: Date[] | undefined;
  rangeDatesInput = input<Date[] | undefined>(undefined);


  contract: ContractModel | undefined;
  branch: BranchModel | undefined;
  servicio: Servicio | undefined;
  display: User | undefined;

  contracts = model<ContractModel[]>();
  branches = model<BranchModel[]>();
  servicios = model<Servicios>();
  displays = model<Users>();

  ngOnInit(): void {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue(
      '--text-color-secondary'
    );
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.getContracts();
    // this.getBranches();
    // this.getServicios();
    this.getDisplays();
    this.getDisplayLogs(this.contract?._id);

    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Changes: ', {changes});
    const previous = changes['rangeDatesInput'].previousValue;
    const current = changes['rangeDatesInput'].currentValue;
    if (!previous || !current) {
      return
    } else if (!Array.isArray(previous) || !Array.isArray(current)) {
      return;
    } else if (previous.length === 0 || current.length === 0) {
      return;
    } else if (
      previous[0].getTime() !== current[0].getTime() ||
      previous[1].getTime() !== current[1].getTime()
    ) {
      const start = new Date(current[0].getTime());
      const end = new Date(current[1].getTime());
      this.rangeDates = [start, end];
      this.getDisplayLogs(this.contract?._id, this.rangeDates, this.display?._id);
      return;
    }
  }

  getDisplayLogs(contract?: string, rangeDates?: Date[], display?: string): void {
    const documentStyle = getComputedStyle(document.documentElement);

    this.displaysLogsService
      .getDisplayLogsCount(contract, rangeDates, display)
      .subscribe((res) => {
        // console.log('Logs: ', res);
        this.basicData = {
          labels: res.logs.map((log) => {
            const date = new Date(log.date);
            const label = new Date(date.getTime() - 4 * 60 * 60 * 1000);
            return label.toLocaleDateString('es', {
              weekday: 'short',
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
            });
          }),
          datasets: [
            {
              label: 'Turnos Por Dia',
              data: res.logs.map((log) => log.count),
              backgroundColor: documentStyle.getPropertyValue('--blue-500'),
              borderColor: documentStyle.getPropertyValue('--blue-500'),
              // backgroundColor: 'rgba(75, 192, 192, 0.2)',
              // borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };
        // console.log('Basic Data: ', this.basicData);
      });
  }

  onRangeDatesChange(event?: any): void {
    console.log('Event: ', event);
    console.log('rangeDates: ', this.rangeDates);
    if (!event || !this.rangeDates?.[0] || !this.rangeDates?.[1]) {
      return;
    }
    this.getDisplayLogs(this.contract?._id, this.rangeDates, this.display?._id);
    // if (this.rangeDates && this.rangeDates.length >= 2) {
    //   const startDate = this.rangeDates[0]
    //   const endDate = this.rangeDates[1]
    //   if (startDate && endDate) {
    //   }
    // }
  }
  onContractChange(event?: DropdownChangeEvent): void {
    console.log('Event: ', event);
    if (!event?.value) {
      return;
    }
    this.getDisplays()
    this.getDisplayLogs(this.contract?._id, this.rangeDates, this.display?._id);
  }
  onDisplayChange(event?: DropdownChangeEvent): void {
    console.log('Event: ', event);
    if (!event?.value) {
      return;
    }
    this.getDisplayLogs(this.contract?._id, this.rangeDates, this.display?._id);
  }

  getContracts(): void {
    if (!this.access()?.contract.actions.read) {
      this.contract = this.profile()?.contract;
      return;
    }
    this.contractService.get().subscribe((data) => {
      this.contracts.update((value) => {
        value = data as ContractModel[];
        return value;
      });
    });
  }

  getBranches(): void {
    if (!this.access()?.branch.actions.read) {
      this.branch = this.profile()?.branch;
      return;
    }
    this.branches.update((value) => {
      value = this.formService.branches().filter((branch) => {
        return (
          !!branch?.contract?._id && branch.contract._id === this.contract?._id
        );
      });
      return value;
    });
  }

  getServicios(): void {
    if (!this.access()?.servicio.actions.read) {
      return;
    }
    this.servicios.update((value) => {
      value = this.formService.servicios().filter((servicio) => {
        return (
          !!servicio?.contract?._id &&
          servicio.contract._id === this.contract?._id
        );
      });
      return value;
    });
  }

  getDisplays(): void {
    if (!this.access()?.display.actions.read) {
      return;
    }
    const params: HttpParams = new HttpParams({
      fromObject: {
        contract: this.contract?._id ?? [],
        branch: this.branch?._id ?? [],
      },
    });
    this.formService
      .getList(this.formService.resources.display, params)
      ?.subscribe((data) => {
        this.displays.update((value) => {
          value = (data as UsersInterface).map((display) => new User(display as UserInterface));
          return value;
        });
      });
  }
}
